module.exports = require("./kgp.d.ts");